<template>
  <div
    v-if="hasBanner"
    v-on-display="{ sectionInfo, context: this }"
    :class="[`multi`, `multi-band-banner`, bannerType]"
    :style="`background-color:${backgroundColor}`"
  >
    <a href="#" @click.prevent="goDetail">
      <img :src="image" :alt="bannerTitle" />
    </a>
  </div>
</template>
<script>
  import { ref, computed } from 'vue'
  import { getEventsFromEventList } from '@/common/utils/get-event-from-event-list'
  import { bannerLink } from '@/common/utils/common'
  import { convertBand } from '@/common/converter/convert-band'
  import { onDisplay } from '@/common/resources/directives'
  import { EventBus } from '@/common/utils/event-bus'
  import { ON_CLICK_CELL } from '@/common/resources/const'
  import { getCellType } from '@/common/utils/home/get-cell-type'

  export default {
    name: 'SingleBannerCatalog',
    directives: {
      onDisplay,
    },
    props: {
      catalogInfo: {
        type: Object,
        default: null,
      },
      sectionInfo: {
        type: Object,
        default: null,
      },
    },
    setup(props) {
      const bannerInfo = ref(null)
      const backgroundColor = ref('')
      const hasBanner = computed(() => bannerInfo.value !== null)

      const image = computed(() => bannerInfo.value?.thumbnail)

      const bgImage = computed(
        () => `background-image:url(${bannerInfo.value?.thumbnail})`,
      )
      const bannerTitle = computed(
        () => `${bannerInfo.value?.title_list?.[0]?.text ?? ''} 바로가기`,
      )
      const bannerType = computed(() =>
        getCellType(props.catalogInfo?.elementList),
      )

      const goDetail = () => {
        const eventList = bannerInfo.value?.event_list
        const { onClick, onNavigation } = getEventsFromEventList(eventList, [
          'onClick',
          'onNavigation',
        ])

        if (onClick) {
          EventBus.$emit(ON_CLICK_CELL, onClick)
        }

        bannerLink(onNavigation?.url ?? '')
      }

      const setData = async () => {
        try {
          const bandInfo = await convertBand(props.catalogInfo)
          bannerInfo.value = bandInfo?.band?.celllist?.[0] ?? null
          backgroundColor.value = bandInfo?.note ?? null
        } catch (error) {
          console.error(error)
        }
      }

      setData()

      return {
        bannerInfo,
        backgroundColor,
        bgImage,
        bannerTitle,
        bannerType,
        hasBanner,
        image,
        goDetail,
        setData,
      }
    },
  }
</script>
<style scoped lang="scss">
  .multi-band-banner {
    > a {
      width: 100%;
      height: 100%;
      > img {
        display: block;
        width: 100%;
        max-width: 1240px;
        margin: 0 auto;
      }
    }
    &.banner_2 {
      height: 96px;
    }
    &.banner_3 {
      height: 200px;
    }
  }
</style>
